import useStep1 from '../../../application/bloc/useStep1';
import useKeypad from '../../../application/hooks/useKeypad';
import { HeadTitle, Spacer, SsnTextField, NumberPad, Button, Popup } from 'oui';
import { SideBox, FloatingBox } from '../../etc/LBox/LBox';
import { MEDIA_NAME } from '../../../application/types/types';
import { isIOS } from 'react-device-detect';
import KTIOSWarning from '../../component/KtIOSWarning';

const Step1 = () => {
  const {
    media,
    devResidentNo,
    setDevResidentNo,
    personal,
    ssnWarning,
    setPersonal,
    openKeypad,
    setKeypad,
    checkUserCertDev: checkUserCert,
    navigate,
    navigateStep3,
    openAlert,
    setAlert,
    inputKeys,
    inputNumber,
    deleteNumber,
    isValidationDev: isValidation,
    checkReuseYn,
  } = useStep1();
  const { keypad } = useKeypad();

  const onClickAlert = () => {
    setAlert(false);
    navigate('/main');
  };
  const onChangeName = (e: any) => {
    setPersonal((prev: any) => {
      return {
        ...prev,
        custNm: e.target.value,
      };
    });
  };
  const onChangeCell = (e: any) => {
    setPersonal((prev: any) => {
      return {
        ...prev,
        cellNo: e.target.value,
      };
    });
  };
  const onChangeResidentNo = (e: any) => {
    setDevResidentNo((prev) => e.target.value);
  };
  const handleClickNextButton = () => {
    checkReuseYn();
    navigateStep3();
    // void checkUserCert();
  };

  return (
    <>
      <HeadTitle textTitle={'주민등록번호 뒷자리를\n 입력해주세요'} />
      {media === MEDIA_NAME.KT && isIOS && (
        <>
          <Spacer size={'md'} />
          <KTIOSWarning />
          <Spacer size={'sm'} />
        </>
      )}
      {(media !== MEDIA_NAME.KT || isIOS) && <Spacer size={'lg'} />}
      <div style={{ backgroundColor: '#d4d4d4', padding: '20px' }}>
        <p>for Dev</p>
        <input
          type={'text'}
          onChange={onChangeName}
          placeholder={'이름'}
          value={personal?.custNm}
        />
        <input
          type={'text'}
          onChange={onChangeCell}
          placeholder={'휴대폰 번호'}
          value={personal?.cellNo}
        />
        <input
          type={'text'}
          onChange={onChangeResidentNo}
          placeholder={'주민등록번호 테스트 계정'}
          value={devResidentNo}
        />
        <p>입력 후 하단 주민번호 입력</p>
      </div>

      <SideBox>
        <SsnTextField
          onClickSsnTextField={() => setKeypad(true)}
          warning={ssnWarning}
          informKeys={personal?.birthDt?.substring(2)}
          selectedKeys={inputKeys}
          focused={openKeypad}
        />
      </SideBox>

      <NumberPad
        isOpen={openKeypad}
        onClickNumber={inputNumber}
        onClickDeleteNumber={deleteNumber}
        onClickCloseNumberPad={() => setKeypad(false)}
        numberList={keypad}
      />

      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          onClick={handleClickNextButton}
          state={'enabled'}
          children={'다음'}
        />
      </FloatingBox>

      <Popup
        isPopupOpen={openAlert}
        title={'인증 횟수가 초과되었어요!\n 다시 시도해주세요'}
        confirmBtn={{ text: '확인', onClick: onClickAlert }}
      />
    </>
  );
};

export default Step1;
